import BasicModel from "./basic_model";

export default class Hotspot extends BasicModel {
  r = function() { return 20 * this.context.scale; }


  render = function() {
    this.setupContext();

    this.context.beginPath();
    this.context.arc(this.x(), this.y(), this.r(), 0, 2 * Math.PI, true);
    this.context.lineWidth = 2
    this.context.fillStyle = "rgba(255, 255, 255, 0.2)";
    this.context.strokeStyle = "rgba(255, 255, 255, 1)";
    this.context.stroke();
    this.context.fill();

    this.resetContext()
  }

  boundingBox = function() {
    const r = this.r();

    return {
      x: this.x() - r,
      y: this.y() - r,
      w: r * 2,
      h: r * 2
    }
  }

}




